import { TorusData } from 'interfaces/torus.interface';
import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Body, ContentGrid, Image, MainModal } from './AuthPopup.styles';
import SignUpForm from './SignUpForm';
import './style.css';

interface IAuthPopupProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  torusData?: TorusData;
}

const AuthPopup: FC<IAuthPopupProps> = ({ open, setOpen, torusData }) => {
  const illustration = require('assets/illustration.png');
  const [token, setToken] = useState<string>('');
  const location = useLocation();
  useEffect(() => {
    if (location.search && !location.search.includes('login')) {
      setToken(location.search.split('=')[1]);
    }
  }, [location]);

  return (
    <>
      <MainModal open={open} onClose={() => setOpen(false)} id="popupScrollbar">
        <Body id="popupScrollbar">
          <ContentGrid sx={{ justifyContent: 'center', padding: 'unset' }}>
            <Image src={illustration} alt={'img'} />
          </ContentGrid>
          <SignUpForm torusData={torusData} creatorToken={token} />
        </Body>
      </MainModal>
    </>
  );
};

export default AuthPopup;
